import { action } from 'typesafe-actions';
import { MapActionTypes } from 'types';

export const setIsOpenMapStylePanel = (isOpen: boolean) =>
  action(MapActionTypes.SET_IS_OPEN_BASE_MAP_PANEL, isOpen);

export const setIsOpenMapLocSearchPanel = (isOpen: boolean) =>
  action(MapActionTypes.SET_IS_OPEN_MAP_LOC_SEARCH_PANEL, isOpen);

export const setMapSearchWithExtentZoom = (withExtentZoom: boolean[]) =>
  action(MapActionTypes.SET_MAP_SEARCH_WITH_EXTENT_ZOOM, withExtentZoom);
